import { Flex, Text } from "@chakra-ui/react";
import React from "react";
export const IonTableLabelHeading = ({
  label,
  numberOfSelectedRows = 0,
  numberOfRows = 0
}) => {
  return /* @__PURE__ */ React.createElement(Flex, { mt: "12px", mb: "4px" }, /* @__PURE__ */ React.createElement(Text, { textStyle: "body-5", color: "gray.600" }, numberOfSelectedRows > 0 ? `${numberOfSelectedRows} of ${numberOfRows} ` : `${numberOfRows} `, numberOfRows === 1 ? `${label} ` : `${label}s `, numberOfSelectedRows > 0 ? "selected" : ""));
};
